/* Native RX measurement: explicit catalogue fields only; no clinical/customer input. */
(function(){
'use strict';
  const createRxTelemetry = ({publish, allowed, context, diagnostic = () => {}, id = () => crypto.randomUUID(), now = () => Date.now(), receiptStorage = {getItem:key => sessionStorage.getItem(key), setItem:(key,value) => sessionStorage.setItem(key,value), removeItem:key => sessionStorage.removeItem(key)}, pageUrl = () => { if (typeof location === 'undefined') return null; const url = new URL(location.href), source = url.searchParams.get('utm_source'); return `${url.origin}${url.pathname}${/^[a-zA-Z0-9_-]{1,100}$/.test(source || '') ? `?utm_source=${source}` : ''}`; }, viewportWidth = () => typeof innerWidth === 'number' ? innerWidth : null}) => {
    const formId = id(); let sequence = 0, cartResultKey = null; const sent = new Set(), pending = new Set();
    const strings = ['rx_step','rx_method','rx_lens_type','rx_package_id','rx_route','rx_field','rx_error_code','rx_option','rx_file_type','rx_file_size_bucket','rx_pair_id','rx_entry_action_id','rx_entry_version','theme_version','rx_material','rx_index','rx_colour','cart_action','action_id','outcome','error_category','close_reason','entry_location'];
    const numbers = ['rx_config_revision','active_time_ms','latency_ms','display_price','total_amount','exposure_threshold_ms','visible_time_ms','rx_visible_percent','rx_feature_mask','rx_base_amount','rx_addon_amount','rx_lens_amount','rx_frame_amount','rx_pair_quantity','quantity','previous_quantity','media_index'];
    const emit = (name, details = {}, onceKey = null) => {
      try {
        if (!allowed()) { diagnostic('blocked_by_consent',name); return false; }
        if (onceKey && sent.has(onceKey)) return false;
        const source = {...context(), ...details}, isRx = name.startsWith('rx_'), payload = {tracking_version:isRx ? 'rx_1' : source.tracking_version==='native_1'?'native_1':'cart_4', ...(isRx ? {rx_form_id:formId} : {}), rx_event_key:`${formId}_${++sequence}`};
        for (const key of strings) if ((isRx || !key.startsWith('rx_')) && typeof source[key] === 'string' && /^[a-zA-Z0-9_-]{1,100}$/.test(source[key])) payload[key] = source[key];
        for (const key of numbers) if ((isRx || !key.startsWith('rx_')) && typeof source[key] === 'number' && Number.isFinite(source[key]) && source[key] >= 0) payload[key] = source[key];
        for (const key of ['rx_retry_reconciled','rx_pd_pending']) if (isRx && typeof source[key] === 'boolean') payload[key] = source[key];
        for (const key of ['product_id','variant_id']) if (/^\d+$/.test(String(source[key] || ''))) payload[key] = String(source[key]);
        if (/^[A-Z]{3}$/.test(source.currency || '')) payload.currency = source.currency;
        payload.is_internal = source.is_internal === true;
        payload.result_final = name.endsWith('_result');
        payload.purchase_stage = 'pre_purchase';
        // Keep only the already-filtered workflow payload, so pixel startup/navigation can recover it.
        try {
          const ack = new Set(JSON.parse(receiptStorage.getItem('er_rx_ack_v1') || '[]'));
          const queue = JSON.parse(receiptStorage.getItem('er_rx_outbox_v1') || '[]');
          const retained = Array.isArray(queue) ? queue.filter(record => !ack.has(record.payload?.rx_event_key) && now()-Date.parse(record.timestamp) < 1800000) : [];
          retained.push({name:`ember_rove:${name}`,payload,timestamp:new Date(now()).toISOString(),page_url:pageUrl(),width:viewportWidth()});
          receiptStorage.setItem('er_rx_outbox_v1',JSON.stringify(retained.slice(-100)));
        } catch (_) { /* Unavailable storage must not interrupt purchasing or direct publication. */ }
        if (onceKey) sent.add(onceKey);
        const publication = Promise.resolve(publish(`ember_rove:${name}`, payload));
        pending.add(publication);
        publication.then(dispatched => { if (dispatched === false) diagnostic('publish_not_dispatched',name); }, () => diagnostic('publish_failed',name)).finally(() => pending.delete(publication));
        if (name === 'rx_cart_result') cartResultKey = payload.rx_event_key;
        diagnostic('published',name);
        return true;
      } catch (_) { diagnostic('preparation_or_publish_failed',name); return false; } // Never interrupt a purchase.
    };
    // A collector receipt is stronger than Shopify dispatch. Never hold a purchase indefinitely.
    const flush = async ({timeoutMs = 900} = {}) => {
      const deadline = Date.now() + timeoutMs;
      let timer;
      try {
        if (!allowed()) return false;
        await Promise.race([Promise.allSettled([...pending]),new Promise(resolve => { timer = setTimeout(resolve,timeoutMs); })]);
        clearTimeout(timer);
        if (!cartResultKey || !receiptStorage) return false;
        while (allowed() && Date.now() < deadline) {
          const receipt = JSON.parse(receiptStorage.getItem('er_rx_receipt_v1') || 'null');
          if (receipt?.event_key === cartResultKey) { receiptStorage.removeItem('er_rx_receipt_v1'); return true; }
          await new Promise(resolve => setTimeout(resolve,25));
        }
      } catch (_) { /* Storage can be unavailable; commerce still proceeds. */ }
      finally { clearTimeout(timer); }
      return false;
    };
    const clearOutbox = () => { for (const key of ['er_rx_outbox_v1','er_rx_ack_v1','er_rx_receipt_v1']) { try { receiptStorage.removeItem(key); } catch (_) {} } };
    return {emit, flush, clearOutbox, formId, now};
  };

if(typeof module==='object'&&module.exports)module.exports={createRxTelemetry};
if(typeof window==='undefined')return;
const allowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
const internal=()=>new URLSearchParams(location.search).get('er_analytics_test')==='1'||!!document.querySelector('.preview-marker');
const publish=(name,payload)=>{window.ERPurchaseNavigation?.observe(name,payload);return window.Shopify?.analytics?.publish?.(name,payload);};
const diagnostic=(state,name)=>{
  if(new URLSearchParams(location.search).get('er_analytics_test')!=='1')return;
  document.documentElement.dataset.erNativeTrackingState=state;
  document.documentElement.dataset.erNativeTrackingEvent=name;
  if(state==='published')document.documentElement.dataset.erNativeTrackingCount=String(Number(document.documentElement.dataset.erNativeTrackingCount||0)+1);
};
let pageEntry=null;
const configuration=(root,entry)=>{
  const type=root.querySelector('[name="rx_preview_type"]:checked')?.value;
  const material=root.querySelector('[name="er_preview_material"]:checked')?.value;
  if(!material)return {};
  const mask=[...root.querySelectorAll('[name="er_preview_feature"]:checked')].reduce((n,input)=>n|Number(input.value),0);
  const id=window.ERLensPackageId(type,material,mask),pack=window.ERLensPackagesFor(entry.product).find(item=>item.id===id);
  if(!pack)return {};
  const options=window.ERLensOptionsFor(pack),selected=root.querySelector('[name="er_preview_lens_colour"]:checked')?.value;
  const colour=options.find(option=>option.id===selected)||(options.length===1?options[0]:null);
  const rows=window.ERLensPriceRows(pack),base=rows[0]?.fee;
  const quantity=Number(root.querySelector('[data-rx-quantity]')?.value||1);
  return {rx_package_id:pack.id,rx_material:material,rx_index:{pc:'1_59',mr8:'1_60',mr7:'1_67',trivex:'1_53'}[material],
    rx_feature_mask:mask,rx_colour:colour?.id,rx_base_amount:base/100,rx_addon_amount:(pack.fee-base)/100,
    rx_lens_amount:pack.fee/100,rx_frame_amount:entry.variant.price/100,
    rx_pair_quantity:quantity,quantity,total_amount:(entry.variant.price+pack.fee)*quantity/100};
};
function entryFor(product,variant){
  if(pageEntry?.product.id===product.id){pageEntry.variant=variant;return pageEntry;}
  const entry={product,variant,action:null,location:null,root:null,legacyContext:null};
  entry.tracker=createRxTelemetry({allowed,publish,diagnostic,context:()=>({
    ...(entry.legacyContext?.()||{}),...(entry.root?configuration(entry.root,entry):{}),
    product_id:product.id,variant_id:entry.variant.id,currency:window.ERTheme.currency,
    rx_entry_version:'entry_6',theme_version:'native_rx_1',rx_route:'direct',
    rx_entry_action_id:entry.action,entry_location:entry.location,is_internal:internal()
  })});
  pageEntry=entry;
  if(new URLSearchParams(location.search).get('er_analytics_test')==='1')document.documentElement.dataset.erNativeTrackingFormId=entry.tracker.formId;
  return entry;
}
function beginEntry(product,variant,location){
  const entry=entryFor(product,variant);entry.root=null;entry.legacyContext=null;
  entry.action=crypto.randomUUID();entry.location=location;
  entry.tracker.emit('rx_entry_clicked',{action_id:entry.action,rx_step:'prescription'});
  entry.tracker.emit('rx_configure_clicked',{action_id:entry.action,rx_step:'prescription'});
  return entry;
}
function attach(root,legacyFactory,options){
  const entry=root.erMeasurementEntry;if(!entry)return legacyFactory(options);
  if(new URLSearchParams(location.search).get('er_analytics_test')==='1')root.dataset.erNativeMeasurementBound='true';
  entry.root=root;entry.legacyContext=options.context;
  const forward=(name,details={},onceKey)=>{
    if(name==='rx_entry_clicked'||name==='rx_configure_clicked'||name==='rx_entry_exposed')return false;
    if(name==='rx_option_changed'&&details.rx_option==='package')return false;
    if(name==='rx_config_opened'||name==='rx_open_result')details={...details,action_id:entry.action,entry_location:entry.location};
    return entry.tracker.emit(name,details,onceKey?entry.action+'_'+onceKey:null);
  };
  root.addEventListener('change',event=>{
    const option={er_preview_material:'material',er_preview_feature:'feature',er_preview_lens_colour:'colour'}[event.target.name];
    if(!option)return;
    queueMicrotask(()=>{
      if(!root.isConnected)return;
      entry.tracker.emit('rx_option_changed',{rx_option:option,action_id:crypto.randomUUID()});
    });
  });
  return {emit:forward,flush:entry.tracker.flush,clearOutbox:entry.tracker.clearOutbox,formId:entry.tracker.formId,now:entry.tracker.now};
}
const exposure=new WeakMap();
function inspectEntries(){
  if(!pageEntry)return;
  for(const button of document.querySelectorAll('#select-lenses,.open-lenses')){
    let state=exposure.get(button);if(!state){state={since:null,sent:false};exposure.set(button,state);}
    if(state.sent)continue;
    const rect=button.getBoundingClientRect(),style=getComputedStyle(button);
    const area=Math.max(0,Math.min(rect.right,innerWidth)-Math.max(rect.left,0))*Math.max(0,Math.min(rect.bottom,innerHeight)-Math.max(rect.top,0));
    const ratio=rect.width*rect.height>0?area/(rect.width*rect.height):0;
    if(!allowed()||document.visibilityState!=='visible'||button.disabled||style.display==='none'||style.visibility==='hidden'||button.closest('[hidden],[aria-hidden="true"]')||document.body.classList.contains('rx-form-open')||ratio<.5){state.since=null;continue;}
    if(state.since===null)state.since=performance.now();
    if(performance.now()-state.since<1000)continue;
    state.sent=pageEntry.tracker.emit('rx_entry_exposed',{entry_location:button.id==='select-lenses'?'rx_product':'rx_sticky',exposure_threshold_ms:1000,visible_time_ms:Math.floor(performance.now()-state.since),rx_visible_percent:Math.floor(ratio*100)});
  }
}
const cartTracker=createRxTelemetry({allowed,publish,context:()=>({theme_version:'native_rx_1',entry_location:'cart_page',currency:window.ERTheme.currency,is_internal:internal()})});
const pageTracker=createRxTelemetry({allowed,publish,context:()=>({tracking_version:'native_1',theme_version:'native_rx_1',currency:window.ERTheme.currency,is_internal:internal()})});
document.addEventListener('click',event=>{
  const target=event.target.closest?.('a,button');if(!target)return;
  const card=target.closest('[data-product]'),swatch=target.closest('[data-card-variant]');
  if(swatch&&card){
    const product=window.ER_DATA.products.find(p=>p.handle===card.dataset.product);
    if(product)pageTracker.emit('collection_swatch_selected',{product_id:product.id,variant_id:swatch.dataset.cardVariant});
  }
  if(target.matches('[data-colour]')&&pageEntry){
    const variant=pageEntry.product.variants.find(v=>String(v.id)===target.dataset.colour);
    if(variant){pageEntry.variant=variant;pageTracker.emit('variant_selected',{product_id:pageEntry.product.id,variant_id:variant.id});}
  }
  if(target.matches('[data-gallery],[data-gallery-shift]')&&pageEntry)queueMicrotask(()=>{
    const thumb=document.querySelector('[data-gallery].selected');
    pageTracker.emit('gallery_image_viewed',{product_id:pageEntry.product.id,variant_id:pageEntry.variant.id,media_index:Number(thumb?.dataset.gallery||0)});
  });
  if(target.matches('a[href]')){
    let url;try{url=new URL(target.href,location.href);}catch{return;}
    if(url.origin!==location.origin)return;
    const handle=url.pathname.match(/\/products\/([^/]+)$/)?.[1];
    const product=window.ER_DATA.products.find(p=>p.handle===handle);
    if(product){
      const variant=product.variants.find(v=>String(v.id)===url.searchParams.get('variant'))||product.variants[0];
      pageTracker.emit('product_card_clicked',{product_id:product.id,variant_id:variant.id,entry_location:window.ERTheme.productHandle?'product_recommendations':location.pathname.includes('/collections/')?'collection':'homepage'});
    }
  }
},true);
function cartEvent(name,details){return cartTracker.emit(name,details);}
window.ERNativeMeasurement={entryFor,beginEntry,attach,configuration,cartEvent,
  openFailed(entry){entry.tracker.emit('rx_open_result',{action_id:entry.action,outcome:'confirmed_failure',rx_error_code:'dialog_open_failed'});},
  cartReady(cart){
    window.ERPurchaseNavigation?.arriveCart('cart_page_dom');
    cartTracker.emit('cart_page_ready',{outcome:'confirmed_success',quantity:window.ERNativeCart.groups(cart).reduce((n,g)=>n+g.quantity,0),total_amount:cart.total_price/100},'cart_ready');
  }
};
document.addEventListener('visitorConsentCollected',()=>{if(!allowed()){cartTracker.clearOutbox();if(pageEntry)pageEntry.action=null;}inspectEntries();});
document.addEventListener('visibilitychange',inspectEntries);
setInterval(inspectEntries,250);
})();
